import React from "react";


const Footer = () => {
    return (

        <div>
            <footer className="mt-auto bg-gray-200 py-2">
                <p className="text-sm text-gray-600 sm:ml-4 sm:pl-4 sm:py-2 sm:mt-0 mt-4 text-center">
                    &copy; {new Date().getFullYear()} Store
                    <a
                        href="https://abc/"
                        className="text-gray-500 ml-1"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        @abc
                    </a>
                </p>
            </footer>
        </div>

    );
};

export default Footer;


